module.exports = __webpack_public_path__ + "static/media/image6.edd47d27.jpg";